// externals
import type { Reducer } from 'redux';

// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';

// action types
import { WS_CONNECTION_FAILED } from '../actionTypes/networkActionTypes';

export interface NetworkState {
    wsConnectionFailed: boolean;
}

export type NetworkReducer = Reducer<NetworkState>;

const initialState: NetworkState = {
    wsConnectionFailed: false
};

export const reducer: NetworkReducer = (state = initialState, action: AnyFSA) => {
    switch (action.type) {
        case WS_CONNECTION_FAILED: {
            return {
                ...state,
                wsConnectionFailed: action.payload
            };
        }
        default:
            return state;
    }
};
